import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  className = 'h-4 w-4'
}: {
  className?: string;
}) {
  return <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-284" data-mp="3gpcni2hxt30v">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${className} fill-accent text-accent`} aria-hidden="true" data-id="element-285" data-mp="3ks9b67mc3pbo" data-mpi={i} />)}
    </div>;
}